import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea, Help } from "rbx";

import { ProductSelect, SystemCodeSelect, BooleanInput } from "../inputs";

const INTERNAL_NOTE_LENGTH_LIMIT = 500;
const EXTERNAL_NOTE_LENGTH_LIMIT = 500;

const OrderDetailBillingForm = ({ inputs, onChange }) => {
  const internalNoteLength = inputs.InternalComm?.length ?? 0;
  const externalNoteLength = inputs.ExternalComm?.length ?? 0;

  const isInternalNoteTooLong =
    internalNoteLength >= INTERNAL_NOTE_LENGTH_LIMIT;
  const isExternalNoteTooLong =
    externalNoteLength >= EXTERNAL_NOTE_LENGTH_LIMIT;
  return (
    <div style={{ width: 600, maxWidth: "100%" }}>
      <Field
        kind="group"
        style={{
          display: "grid",
          gridAutoFlow: "column",
          gridTemplateColumns: "1fr 1fr"
        }}
      >
        <Control expanded>
          <ProductSelect
            icon="globe"
            label="Product"
            name="ProductRecIdRef"
            value={inputs.ProductRecIdRef}
            valueKey="RecId"
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
        <Control expanded>
          <SystemCodeSelect
            icon="balance-scale-right"
            label="UOM"
            lookup={{ Category: "Order", Code: "UOM" }}
            name="UOMRecIdRef"
            showHelp={false}
            value={inputs.UOMRecIdRef}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Quantity</Label>
          <Input
            autoComplete="new"
            name="Quantity"
            type="number"
            value={inputs.Quantity}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
        <Control expanded>
          <Label>Rate</Label>
          <Input
            autocomplete="new"
            defaultValue="1"
            name="Rate"
            type="number"
            value={inputs.Rate}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
        <Control expanded>
          <Label>Percentage</Label>
          <Input
            autoComplete="new"
            name="Percentage"
            type="number"
            value={inputs.Percentage}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
      </Field>
      <Field>
        <Control>
          <Label>Description</Label>
          <Textarea
            name="Description"
            rows="2"
            value={inputs.Description}
            valueKey="RecId"
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>External Comment</Label>
          <Textarea
            maxLength={EXTERNAL_NOTE_LENGTH_LIMIT}
            name="ExternalComm"
            rows="2"
            value={inputs.ExternalComm}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
          <Help color={isExternalNoteTooLong ? "danger" : "primary"}>
            {`${externalNoteLength} / ${EXTERNAL_NOTE_LENGTH_LIMIT} Characters`}
          </Help>
        </Control>

        <Control expanded>
          <Label>Internal Comment</Label>
          <Textarea
            maxLength={INTERNAL_NOTE_LENGTH_LIMIT}
            name="InternalComm"
            rows="2"
            value={inputs.InternalComm}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
          <Help color={isInternalNoteTooLong ? "danger" : "primary"}>
            {`${internalNoteLength} / ${INTERNAL_NOTE_LENGTH_LIMIT} Characters`}
          </Help>
        </Control>
      </Field>
      <Field>
        <Control>
          <Label>Product Notes</Label>
          <Textarea
            name="Note"
            rows="2"
            value={inputs.Note}
            onChange={({ target: { name, value } }) => onChange(name, value)}
          />
        </Control>
      </Field>
      <Field>
        <Control>
          <Label>Override Flag</Label>
          <BooleanInput
            name="OverrideFlag"
            value={inputs.OverrideFlag}
            onChange={({ target: { name, checked } }) =>
              onChange(name, checked)
            }
          />
        </Control>
      </Field>
    </div>
  );
};
OrderDetailBillingForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default OrderDetailBillingForm;
